import { testimonial, trustBadges } from '@/mocks/homeContent';

export default function TestimonialSection() {
  return (
    <section className="relative py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-14 md:mb-16">
          <p className="text-xs tracking-[0.2em] uppercase text-foreground-500 font-medium mb-3">
            (What Buyers Say)
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            Trusted by Thousands of Shoppers
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 md:gap-14 items-center">
          <div className="lg:w-2/5">
            <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/70">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent-500 rounded-full mb-6">
                <i className="ri-star-fill text-white text-sm"></i>
                <span className="text-white text-sm font-semibold whitespace-nowrap">{testimonial.rating}</span>
              </div>
              <blockquote className="text-lg md:text-xl font-heading italic text-foreground-800 leading-relaxed mb-6">
                &ldquo;{testimonial.text}&rdquo;
              </blockquote>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-accent-200 flex items-center justify-center">
                  <span className="text-accent-700 font-semibold text-sm">{testimonial.author.charAt(0)}</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{testimonial.author}</p>
                  <p className="text-xs text-foreground-500">{testimonial.info}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:w-3/5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {trustBadges.map((badge, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 bg-background-50 rounded-xl p-5 border border-background-200/70"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className={`${badge.icon} text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">{badge.title}</h4>
                    <p className="text-xs text-foreground-600">{badge.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}